import { Message, MessageBox } from 'element-ui'
export function message(msg,type){
  Message({
    message: msg,
    type:type,
    duration: 3 * 1000
  })
}





// WEBPACK FOOTER //
// ./src/utils/message.js